module.exports = __webpack_public_path__ + "img/quicklinks.b0b20342.svg";